import { useTranslation } from 'react-i18next'
import { InputAdornment, TextField } from '@mui/material'
import { Search } from '@mui/icons-material'

import { PersonalizationEngineModels } from '@/state/personalization-engine'

type Props = {
  filters: PersonalizationEngineModels.PersonalizationEngineFiltersType
  handleChangeSearch: (field: string, value: string, debounce?: boolean) => void
}

export const SearchByPlayerComponent = ({
  filters,
  handleChangeSearch,
}: Props) => {
  const { t } = useTranslation()

  return (
    <TextField
      autoComplete="off"
      fullWidth
      name="name"
      label={t('labels.searchByPlayerId')}
      margin="dense"
      variant="outlined"
      value={filters.playerId || ''}
      onChange={(e: React.ChangeEvent<{ value: string }>) => {
        handleChangeSearch('playerId', e.target.value.trimStart(), true)
      }}
      InputProps={{
        inputProps: {
          maxLength: 100,
        },
        endAdornment: (
          <InputAdornment position="end">
            <Search />
          </InputAdornment>
        ),
      }}
    />
  )
}
